// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/admin/images/copy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/admin/images/print.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-settings-container .dYjDdw {
  min-width: 180px;
}
.ultimate-security-settings-container .mb-30 {
  margin-bottom: 30px;
}
.ultimate-security-settings-container .pb-30 {
  padding-bottom: 30px;
}
.ultimate-security-settings-container .container-fluid {
  padding: 30px;
}
.ultimate-security-settings-container a {
  color: var(--plus-color-purple-50);
}
.ultimate-security-settings-container .button {
  border: 1px solid var(--plus-color-purple-40);
  padding: 8px 12px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
}
.ultimate-security-settings-container .button.button-link {
  color: var(--plus-color-purple-40);
  border-style: none;
  padding-left: 0;
  background-color: transparent !important;
  outline: none;
  box-shadow: none;
}
.ultimate-security-settings-container .button.button-primary {
  background-color: var(--plus-color-purple-40);
  color: #ffffff;
}
.ultimate-security-settings-container .button.button-secondary {
  color: var(--plus-color-purple-40);
  background-color: transparent;
}
.ultimate-security-settings-container .icon-clicked {
  transform: scale(1.3);
}
.ultimate-security-settings-container .hint-tooltip {
  color: #d8d9db;
}
.ultimate-security-settings-container .form-control-plaintext,
.ultimate-security-settings-container select,
.ultimate-security-settings-container input[type=text],
.ultimate-security-settings-container input[type=date],
.ultimate-security-settings-container input[type=datetime-local],
.ultimate-security-settings-container input[type=email],
.ultimate-security-settings-container input[type=time],
.ultimate-security-settings-container input[type=tel],
.ultimate-security-settings-container input[type=url],
.ultimate-security-settings-container textarea,
.ultimate-security-settings-container tags.tagify {
  border: 1px solid rgba(60, 67, 74, 0.5019607843);
  background-color: transparent;
  padding: 7px 10px;
  border-radius: 3px;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  width: 100%;
  max-width: 375px;
}
.ultimate-security-settings-container .form-control-plaintext,
.ultimate-security-settings-container select,
.ultimate-security-settings-container input[type=text],
.ultimate-security-settings-container input[type=number],
.ultimate-security-settings-container input[type=date],
.ultimate-security-settings-container input[type=datetime-local],
.ultimate-security-settings-container input[type=email],
.ultimate-security-settings-container input[type=time],
.ultimate-security-settings-container input[type=tel],
.ultimate-security-settings-container input[type=url],
.ultimate-security-settings-container tags.tagify {
  min-height: 40px;
}
.ultimate-security-settings-container .tagify__tag > div::before {
  animation: none !important;
}
.ultimate-security-settings-container .w-130 {
  width: 100%;
  max-width: 130px;
}
.ultimate-security-settings-container .w-375 {
  width: 100%;
  max-width: 375px;
}
.ultimate-security-settings-container .form-control-plaintext {
  height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.ultimate-security-settings-container tags.tagify {
  padding: 4px;
  display: flex;
  gap: 4px;
}
.ultimate-security-settings-container tags.tagify .tagify__tag {
  margin: 0;
}
.ultimate-security-settings-container .deactive-section {
  opacity: 0.5;
  position: relative;
}
.ultimate-security-settings-container .deactive-section::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
  z-index: 1;
}
.ultimate-security-settings-container .setting-unit .title-group {
  gap: 6px;
}
.ultimate-security-settings-container .setting-unit .title-group h5 {
  margin-bottom: 12px;
}
.ultimate-security-settings-container .setting-unit .title-group p {
  opacity: 0.5;
}
.ultimate-security-settings-container .setting-unit .title-group > *:last-child {
  margin-bottom: 0;
}
.ultimate-security-settings-container .setting-unit .filter-wrapper .filter-btn {
  margin: 4px;
  background-color: transparent;
  border-style: none;
  box-shadow: none;
  padding: 8px 16px;
  color: var(--plus-color-text);
}
.ultimate-security-settings-container .setting-unit .filter-wrapper .filter-btn.active {
  background-color: var(--plus-color-secondary);
}
.ultimate-security-settings-container .setting-unit .units .unit {
  font-weight: 600;
  font-size: 14;
  line-height: 20px;
  letter-spacing: 1%;
  padding: 0 12px;
  cursor: pointer;
  display: inline-block;
}
.ultimate-security-settings-container .setting-unit .units .unit.active-unit {
  color: var(--plus-color-purple-40);
}
.ultimate-security-settings-container .setting-unit .units .unit + .unit {
  border-left: 1px solid #d8d9db;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel {
  border: 1px solid var(--plus-color-border);
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel .panel-header,
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel .panel-footer {
  background-color: var(--plus-color-notice);
  color: #1d2327;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 18px 24px;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel .panel-header {
  border-bottom: 1px solid var(--plus-color-border);
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel .panel-body {
  padding: 24px;
  max-height: 288px;
  overflow-y: auto;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .panel .panel-footer {
  border-top: 1px solid var(--plus-color-border);
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .info {
  background-color: var(--plus-color-notice);
  border: 1px solid var(--plus-color-border);
  padding: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .action-buttons {
  gap: 24px;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .action-buttons button {
  color: #50575e;
  border-style: none;
  background-color: transparent;
  padding: 0;
  height: unset;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .action-buttons button::before {
  content: "";
  width: 20px;
  height: 20px;
  display: inline-block;
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .action-buttons button.copy-content::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ultimate-security-settings-container .setting-unit .panel-wrapper .action-buttons button.print-content::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.ultimate-security-settings-container .content-below-with-hint {
  margin-left: 26px;
}
.ultimate-security-settings-container .usw-alert-note {
  background-color: #fff1bc;
  color: #3c434a;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  border-radius: 30px;
  padding: 8px 12px;
}
.ultimate-security-settings-container .usw-alert-note b,
.ultimate-security-settings-container .usw-alert-note strong {
  font-weight: 600;
}
.ultimate-security-settings-container .fade-out {
  opacity: 1; /* Start fully visible */
  animation: fadeOut 3s forwards; /* Apply the fadeOut animation for 3 seconds */
}
@keyframes fadeOut {
  0% {
    opacity: 1; /* Fully visible at the start */
  }
  100% {
    opacity: 0; /* Fully transparent at the end */
  }
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableHead .rdt_TableHeadRow {
  background-color: #fffdee;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  padding-top: 13px;
  padding-bottom: 13px;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:first-child {
  justify-content: flex-start !important;
  padding-left: 16px;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  color: #50575e;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .login-details {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  justify-content: end;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .login-details .logout-button {
  color: #d53637;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  background-color: #f1f1f1;
  padding: 8px 12px;
  height: unset;
  border-radius: 50rem;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell .formated-time {
  color: #757575;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.ultimate-security-settings-container .datatable-unit .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
  justify-content: flex-start !important;
  padding-left: 16px;
}
.ultimate-security-settings-container .user-datatable .filters .wp-roles span {
  cursor: pointer;
  display: inline-block;
  margin-bottom: 8px;
  line-height: 1;
  color: #1d2327;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.ultimate-security-settings-container .user-datatable .filters .wp-roles span + span {
  padding-left: 8px;
  margin-left: 8px;
  border-left: 1px solid rgba(29, 35, 39, 0.5019607843);
}
.ultimate-security-settings-container .user-datatable .filters .wp-roles span.active {
  color: var(--plus-color-purple-70);
}
.ultimate-security-settings-container .user-datatable .filters .bulk-action-wrapper {
  margin-top: 16px;
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.ultimate-security-settings-container .user-datatable .filters .bulk-action-wrapper select {
  border: 1px solid #d8d9db;
  border-radius: 3px;
  min-width: 110px;
}
.ultimate-security-settings-container .user-datatable .action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.ultimate-security-settings-container .user-datatable .action-buttons span {
  color: var(--plus-color-purple-90);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;
}
.ultimate-security-settings-container .user-datatable .action-buttons span + span {
  border-left: 1px solid #9da1a4;
  padding-left: 16px;
  margin-left: 16px;
}
.ultimate-security-settings-container .user-datatable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  justify-content: flex-start !important;
  color: #50575e;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.41px;
}
.ultimate-security-settings-container .user-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  padding-top: 11px;
  padding-bottom: 11px;
}
.ultimate-security-settings-container .user-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell[data-column-id=username] b, .ultimate-security-settings-container .user-datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell[data-column-id=email] {
  color: var(--plus-color-purple-90);
}
.ultimate-security-settings-container .table-wrapper {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.ultimate-security-settings-container .table-wrapper .rdt_Pagination {
  background-color: #fffdee;
}
.ultimate-security-settings-container .table-wrapper .rdt_Pagination select + svg {
  display: none;
}
.ultimate-security-settings-container .other-plugins-container {
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #3c434a;
}
.ultimate-security-settings-container .other-plugins-container a {
  color: #2271b1;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  border: 1px solid #d8d9db;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-content {
  display: flex;
  gap: 20px;
  justify-content: space-between;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-content .plugin-info .info-container h2.plugin-title {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 12px;
  color: #2271b1;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-content .plugin-buttons {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-content .plugin-buttons a {
  display: block;
  margin-bottom: 10px;
  white-space: nowrap;
  text-decoration: none;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-content .plugin-buttons a.install-button {
  padding: 5px 10px;
  border: 1px solid #2271b1;
  border-radius: 3px;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-footer {
  background-color: #f6f7f7;
  border-top: 1px solid #d8d9db;
}
.ultimate-security-settings-container .other-plugins-container .plugin-grid-item .plugin-unit .plugin-footer .rating-section .stars-container {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss"],"names":[],"mappings":"AACC;EACC,gBAAA;AAAF;AAEC;EACC,mBAAA;AAAF;AAEC;EACC,oBAAA;AAAF;AAEC;EACC,aAAA;AAAF;AAEC;EACC,kCAAA;AAAF;AAEC;EACC,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAAF;AACE;EACC,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,aAAA;EACE,gBAAA;AACL;AACE;EACC,6CAAA;EACA,cAAA;AACH;AACE;EACC,kCAAA;EACA,6BAAA;AACH;AAEC;EACC,qBAAA;AAAF;AAEC;EACC,cAAA;AAAF;AAEC;;;;;;;;;;;EAYC,gDAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AADF;AAGC;;;;;;;;;;;EAWC,gBAAA;AADF;AAGC;EACC,0BAAA;AADF;AAGC;EACC,WAAA;EACA,gBAAA;AADF;AAGC;EACC,WAAA;EACA,gBAAA;AADF;AAGC;EACC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAGC;EACC,YAAA;EACA,aAAA;EACA,QAAA;AADF;AAEE;EACC,SAAA;AAAH;AAGC;EACC,YAAA;EACA,kBAAA;AADF;AAEE;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAAH;AAIE;EACC,QAAA;AAFH;AAGG;EACC,mBAAA;AADJ;AAGG;EACC,YAAA;AADJ;AAGG;EACC,gBAAA;AADJ;AAKG;EACC,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAHJ;AAII;EACC,6CAAA;AAFL;AAOG;EACC,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AALJ;AAMI;EACC,kCAAA;AAJL;AAMI;EACC,8BAAA;AAJL;AAUG;EACC,0CAAA;AARJ;AASI;;EAEC,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAPL;AASI;EACC,iDAAA;AAPL;AASI;EACC,aAAA;EACA,iBAAA;EACA,gBAAA;AAPL;AASI;EACC,8CAAA;AAPL;AAUG;EACC,0CAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AARJ;AAUG;EACC,SAAA;AARJ;AASI;EACC,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;AAPL;AAQK;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AANN;AASM;EACC,gDAAA;AAPP;AAWM;EACC,gDAAA;AATP;AAgBC;EACC,iBAAA;AAdF;AAgBC;EACC,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAdF;AAeE;;EAEC,gBAAA;AAbH;AAgBC;EACC,UAAA,EAAA,wBAAA;EACA,8BAAA,EAAA,8CAAA;AAdF;AAiBC;EACC;IACC,UAAA,EAAA,+BAAA;EAfD;EAiBA;IACC,UAAA,EAAA,iCAAA;EAfD;AACF;AAqBI;EACC,yBAAA;AAnBL;AAoBK;EACC,iBAAA;EACA,oBAAA;AAlBN;AAmBM;EACC,sCAAA;EACA,kBAAA;AAjBP;AA4BK;EACC,cAAA;AA1BN;AA2BM;EACC,aAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AAzBP;AA0BO;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;AAxBR;AA2BM;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAzBP;AA2BM;EACC,sCAAA;EACA,kBAAA;AAzBP;AAmCI;EACC,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAjCL;AAmCK;EACC,iBAAA;EACA,gBAAA;EACA,qDAAA;AAjCN;AAmCK;EACC,kCAAA;AAjCN;AAqCG;EACC,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,QAAA;AAnCJ;AAoCI;EACC,yBAAA;EACA,kBAAA;EACA,gBAAA;AAlCL;AAsCE;EACC,aAAA;EACA,yBAAA;EACA,gBAAA;AApCH;AAqCG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,eAAA;AAnCJ;AAoCI;EACC,8BAAA;EACA,kBAAA;EACA,iBAAA;AAlCL;AAyCK;EACC,sCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAvCN;AA6CK;EACC,iBAAA;EACA,oBAAA;AA3CN;AA4CM;EAEC,kCAAA;AA3CP;AAkDC;EACC,kBAAA;EACA,qCAAA;AAhDF;AAiDE;EACC,yBAAA;AA/CH;AAiDI;EACC,aAAA;AA/CL;AAqDC;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnDF;AAoDE;EACC,cAAA;AAlDH;AAqDG;EACC,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;AAnDJ;AAoDI;EACC,aAAA;EACA,SAAA;EACA,8BAAA;AAlDL;AAyDO;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAvDR;AA2DK;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;AAzDN;AA0DM;EACC,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAxDP;AAyDO;EACC,iBAAA;EACA,yBAAA;EACA,kBAAA;AAvDR;AA4DI;EACC,yBAAA;EACA,6BAAA;AA1DL;AA4DM;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA1DP","sourcesContent":[".ultimate-security-settings-container {\n\t.dYjDdw {\n\t\tmin-width: 180px;\n\t}\n\t.mb-30 {\n\t\tmargin-bottom: 30px;\n\t}\n\t.pb-30 {\n\t\tpadding-bottom: 30px;\n\t}\n\t.container-fluid {\n\t\tpadding: 30px;\n\t}\n\ta {\n\t\tcolor: var(--plus-color-purple-50);\n\t}\n\t.button {\n\t\tborder: 1px solid var(--plus-color-purple-40);\n\t\tpadding: 8px 12px;\n\t\tborder-radius: 3px;\n\t\tfont-weight: 500;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0%;\n\t\t&.button-link {\n\t\t\tcolor: var(--plus-color-purple-40);\n\t\t\tborder-style: none;\n\t\t\tpadding-left: 0;\n\t\t\tbackground-color: transparent !important;\n\t\t\toutline: none;\n  \t\t\tbox-shadow: none;\n\t\t}\n\t\t&.button-primary {\n\t\t\tbackground-color: var(--plus-color-purple-40);\n\t\t\tcolor: #ffffff;\n\t\t}\n\t\t&.button-secondary {\n\t\t\tcolor: var(--plus-color-purple-40);\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\t.icon-clicked {\n\t\ttransform: scale(1.3);\n\t}\n\t.hint-tooltip {\n\t\tcolor: #d8d9db;\n\t}\n\t.form-control-plaintext,\n\tselect,\n\tinput[type=\"text\"],\n\t// input[type=\"number\"],\n\tinput[type=\"date\"],\n\tinput[type=\"datetime-local\"],\n\tinput[type=\"email\"],\n\tinput[type=\"time\"],\n\tinput[type=\"tel\"],\n\tinput[type=\"url\"],\n\ttextarea,\n\ttags.tagify {\n\t\tborder: 1px solid #3c434a80;\n\t\tbackground-color: transparent;\n\t\tpadding: 7px 10px;\n\t\tborder-radius: 3px;\n\t\tcolor: #3c434a;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 22px;\n\t\tletter-spacing: 0%;\n\t\twidth: 100%;\n\t\tmax-width: 375px;\n\t}\n\t.form-control-plaintext,\n\tselect,\n\tinput[type=\"text\"],\n\tinput[type=\"number\"],\n\tinput[type=\"date\"],\n\tinput[type=\"datetime-local\"],\n\tinput[type=\"email\"],\n\tinput[type=\"time\"],\n\tinput[type=\"tel\"],\n\tinput[type=\"url\"],\n\ttags.tagify {\n\t\tmin-height: 40px;\n\t}\n\t.tagify__tag>div::before{\n\t\tanimation: none !important;\n\t}\n\t.w-130 {\n\t\twidth: 100%;\n\t\tmax-width: 130px;\n\t}\n\t.w-375 {\n\t\twidth: 100%;\n\t\tmax-width: 375px;\n\t}\n\t.form-control-plaintext {\n\t\theight: 40px;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t}\n\ttags.tagify {\n\t\tpadding: 4px;\n\t\tdisplay: flex;\n\t\tgap: 4px;\n\t\t.tagify__tag {\n\t\t\tmargin: 0;\n\t\t}\n\t}\n\t.deactive-section {\n\t\topacity: 0.5;\n\t\tposition: relative;\n\t\t&::after {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tcontent: \"\";\n\t\t\tz-index: 1;\n\t\t}\n\t}\n\t.setting-unit {\n\t\t.title-group {\n\t\t\tgap: 6px;\n\t\t\th5 {\n\t\t\t\tmargin-bottom: 12px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\topacity: 0.5;\n\t\t\t}\n\t\t\t> *:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t\t.filter-wrapper {\n\t\t\t.filter-btn {\n\t\t\t\tmargin: 4px;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\tborder-style: none;\n\t\t\t\tbox-shadow: none;\n\t\t\t\tpadding: 8px 16px;\n\t\t\t\tcolor: var(--plus-color-text);\n\t\t\t\t&.active {\n\t\t\t\t\tbackground-color: var(--plus-color-secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.units {\n\t\t\t.unit {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 14;\n\t\t\t\tline-height: 20px;\n\t\t\t\tletter-spacing: 1%;\n\t\t\t\tpadding: 0 12px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\t&.active-unit {\n\t\t\t\t\tcolor: var(--plus-color-purple-40);\n\t\t\t\t}\n\t\t\t\t+ .unit {\n\t\t\t\t\tborder-left: 1px solid #d8d9db;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.panel-wrapper {\n\t\t\t\n\t\t\t.panel {\n\t\t\t\tborder: 1px solid var(--plus-color-border);\n\t\t\t\t.panel-header,\n\t\t\t\t.panel-footer {\n\t\t\t\t\tbackground-color: var(--plus-color-notice);\n\t\t\t\t\tcolor: #1d2327;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tpadding: 18px 24px;\n\t\t\t\t}\n\t\t\t\t.panel-header {\n\t\t\t\t\tborder-bottom: 1px solid var(--plus-color-border);\n\t\t\t\t}\n\t\t\t\t.panel-body {\n\t\t\t\t\tpadding: 24px;\n\t\t\t\t\tmax-height: 288px;\n\t\t\t\t\toverflow-y: auto;\n\t\t\t\t}\n\t\t\t\t.panel-footer {\n\t\t\t\t\tborder-top: 1px solid var(--plus-color-border);\n\t\t\t\t}\n\t\t\t}\n\t\t\t.info {\n\t\t\t\tbackground-color: var(--plus-color-notice);\n\t\t\t\tborder: 1px solid var(--plus-color-border);\n\t\t\t\tpadding: 8px;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 22px;\n\t\t\t}\n\t\t\t.action-buttons {\n\t\t\t\tgap: 24px;\n\t\t\t\tbutton {\n\t\t\t\t\tcolor: #50575e;\n\t\t\t\t\tborder-style: none;\n\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\theight: unset;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 10px;\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\theight: 20px;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n\t\t\t\t\t&.copy-content {\n\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\tcontent: url('../assets/admin/images/copy.svg');\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.print-content {\n\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\tcontent: url('../assets/admin/images/print.svg');\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.content-below-with-hint {\n\t\tmargin-left: 26px;\n\t}\n\t.usw-alert-note {\n\t\tbackground-color: #fff1bc;\n\t\tcolor: #3c434a;\n\t\tfont-weight: 400;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tletter-spacing: 0%;\n\t\tborder-radius: 30px;\n\t\tpadding: 8px 12px;\n\t\tb,\n\t\tstrong {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\t.fade-out {\n\t\topacity: 1; /* Start fully visible */\n\t\tanimation: fadeOut 3s forwards; /* Apply the fadeOut animation for 3 seconds */\n\t}\n\n\t@keyframes fadeOut {\n\t\t0% {\n\t\t\topacity: 1; /* Fully visible at the start */\n\t\t}\n\t\t100% {\n\t\t\topacity: 0; /* Fully transparent at the end */\n\t\t}\n\t}\n\n\t.datatable-unit {\n\t\t.rdt_Table {\n\t\t\t.rdt_TableHead {\n\t\t\t\t.rdt_TableHeadRow {\n\t\t\t\t\tbackground-color: #fffdee;\n\t\t\t\t\t.rdt_TableCol {\n\t\t\t\t\t\tpadding-top: 13px;\n\t\t\t\t\t\tpadding-bottom: 13px;\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tjustify-content: flex-start !important;\n\t\t\t\t\t\t\tpadding-left: 16px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t// &:last-child {\n\t\t\t\t\t\t//   justify-content: flex-end!important;\n\t\t\t\t\t\t//   padding-RIGHT: 11px;\n\t\t\t\t\t\t// }\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.rdt_TableBody {\n\t\t\t\t.rdt_TableRow {\n\t\t\t\t\t.rdt_TableCell {\n\t\t\t\t\t\tcolor: #50575e;\n\t\t\t\t\t\t.login-details {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tgap: 8px;\n\t\t\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\t\t\tjustify-content: end;\n\t\t\t\t\t\t\t.logout-button {\n\t\t\t\t\t\t\t\tcolor: #d53637;\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t\tbackground-color: #f1f1f1;\n\t\t\t\t\t\t\t\tpadding: 8px 12px;\n\t\t\t\t\t\t\t\theight: unset;\n\t\t\t\t\t\t\t\tborder-radius: 50rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.formated-time {\n\t\t\t\t\t\t\tcolor: #757575;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:first-child {\n\t\t\t\t\t\t\tjustify-content: flex-start !important;\n\t\t\t\t\t\t\tpadding-left: 16px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.user-datatable {\n\t\t.filters {\n\t\t\t.wp-roles {\n\t\t\t\tspan {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tmargin-bottom: 8px;\n\t\t\t\t\tline-height: 1;\n\t\t\t\t\tcolor: #1d2327;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 20px;\n\n\t\t\t\t\t+ span {\n\t\t\t\t\t\tpadding-left: 8px;\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t\tborder-left: 1px solid #1d232780;\n\t\t\t\t\t}\n\t\t\t\t\t&.active {\n\t\t\t\t\t\tcolor: var(--plus-color-purple-70);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.bulk-action-wrapper {\n\t\t\t\tmargin-top: 16px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: stretch;\n\t\t\t\tgap: 8px;\n\t\t\t\tselect {\n\t\t\t\t\tborder: 1px solid #d8d9db;\n\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\tmin-width: 110px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.action-buttons {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\t\t\tmargin-top: 16px;\n\t\t\tspan {\n\t\t\t\tcolor: var(--plus-color-purple-90);\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tline-height: 20px;\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tcursor: pointer;\n\t\t\t\t+ span {\n\t\t\t\t\tborder-left: 1px solid #9da1a4;\n\t\t\t\t\tpadding-left: 16px;\n\t\t\t\t\tmargin-left: 16px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.rdt_Table {\n\t\t\t.rdt_TableHead {\n\t\t\t\t.rdt_TableHeadRow {\n\t\t\t\t\t.rdt_TableCol {\n\t\t\t\t\t\tjustify-content: flex-start !important;\n\t\t\t\t\t\tcolor: #50575e;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tline-height: 16.41px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.rdt_TableBody {\n\t\t\t\t.rdt_TableRow {\n\t\t\t\t\t.rdt_TableCell {\n\t\t\t\t\t\tpadding-top: 11px;\n\t\t\t\t\t\tpadding-bottom: 11px;\n\t\t\t\t\t\t&[data-column-id=\"username\"] b,\n\t\t\t\t\t\t&[data-column-id=\"email\"] {\n\t\t\t\t\t\t\tcolor: var(--plus-color-purple-90);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.table-wrapper {\n\t\tposition: relative;\n\t\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\t\t.rdt_Pagination {\n\t\t\tbackground-color: #fffdee;\n\t\t\tselect {\n\t\t\t\t+ svg {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.other-plugins-container {\n\t\tfont-weight: 400;\n\t\tfont-size: 13px;\n\t\tline-height: 20px;\n\t\tcolor: #3c434a;\n\t\ta {\n\t\t\tcolor: #2271b1;\n\t\t}\n\t\t.plugin-grid-item {\n\t\t\t.plugin-unit {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\theight: 100%;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tborder: 1px solid #d8d9db;\n\t\t\t\t.plugin-content {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tgap: 20px;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t.plugin-image {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.plugin-info {\n\t\t\t\t\t\t.info-container {\n\t\t\t\t\t\t\th2.plugin-title {\n\t\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t\t\tmargin-bottom: 12px;\n\t\t\t\t\t\t\t\tcolor: #2271b1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.plugin-buttons {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\talign-items: end;\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\t&.install-button {\n\t\t\t\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\t\t\t\tborder: 1px solid #2271b1;\n\t\t\t\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.plugin-footer {\n\t\t\t\t\tbackground-color: #f6f7f7;\n\t\t\t\t\tborder-top: 1px solid #d8d9db;\n\t\t\t\t\t.rating-section {\n\t\t\t\t\t\t.stars-container {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tgap: 4px;\n\t\t\t\t\t\t\tmargin-bottom: 4px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.installation-count {\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
